/* eslint-disable */
import axios from "axios";
import store from "@/store/index";
import * as CONSTANTS from '../store/constants'
import "isomorphic-fetch";
import { Client } from "@microsoft/microsoft-graph-client";

const error = CONSTANTS.MICROSOFT_GRAPH_AUTH_ERROR;

const microsoftGraphClient = Client.init({
    defaultVersion: "v1.0",
    debugLogging: false,
    authProvider: (done) => {
        done(error, store.getters.authResponse.user.azureAccessToken);
    },
});

const helpHubInstance = axios.create({
    baseURL: HELPHUB_BASEURL
});

const serverlessHubInstance = axios.create({
    baseURL: SERVERLESS_HUB_BASE_URL
});
const bookmarkInstance = axios.create({
    baseURL: BOOKMARK_HELPHUB_BASEURL
});
var serviceNowInstance = axios.create({
    baseURL: SERVICENOW_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': '*',
    }
});

const autodeskOneWolkenProxyInstance = axios.create({
    baseURL: AUTODESK_ONE_WOLKEN_PROXY_BASE_URL
});

const graphInstance = axios.create({
    baseURL: CONSTANTS.GRAPH_BASE_URL,
    headers: { consistencyLevel: "eventual" },
});

const employeeHubNewsInstance = axios.create({
    baseURL: EMPLOYEE_HUB_NEWS_BASE_URL
});

const aoneGenAiInstance = axios.create({
    baseURL: AONE_GEN_AI_BASE_URL
});

const aoneMobileInstance = axios.create({
    baseURL: AONE_MOBILE_BASE_URL
});

// add interceptors
const defaultInterceptorHandler = (config) => {

    const token = store.getters.authResponse.accessToken
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}

helpHubInstance.interceptors.request.use(
    defaultInterceptorHandler,
    error => Promise.reject(error)
);
serverlessHubInstance.interceptors.request.use(
    defaultInterceptorHandler,
    error => Promise.reject(error)
); 
autodeskOneWolkenProxyInstance.interceptors.request.use(
    defaultInterceptorHandler,
    error => Promise.reject(error)
);


serviceNowInstance.interceptors.request.use(
    config => {
        if (config.baseURL == SERVICENOW_BASE_URL && !config.headers.Authorization) {

            const token = store.getters.authResponse.idToken
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        return config;
    },
    error => Promise.reject(error)
);

graphInstance.interceptors.request.use(
    config => {

        if (config.baseURL == CONSTANTS.GRAPH_BASE_URL && !config.headers.Authorization) {
            const token = store.getters.authResponse.user.azureAccessToken;
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        return config;
    },
    error => Promise.reject(error)
);

employeeHubNewsInstance.interceptors.request.use(
    config => {

        if (config.baseURL == EMPLOYEE_HUB_NEWS_BASE_URL && !config.headers.Authorization) {
            const token = store.getters.authResponse.user.azureAccessToken;
            if (token) {
                config.headers.Authorization = token;
            }
        }

        return config;
    },
    error => Promise.reject(error)
);

bookmarkInstance.interceptors.request.use(
    config => {
        if (config.baseURL == BOOKMARK_HELPHUB_BASEURL && !config.headers.Authorization) {
            const token = store.getters.authResponse.user.azureAccessToken;
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;
    },
    error => Promise.reject(error)
);

aoneGenAiInstance.interceptors.request.use(
    config => {
        if (config.baseURL === AONE_GEN_AI_BASE_URL && !config.headers.Authorization) {
            const token = store.getters.authResponse.user.azureAccessToken;
            if (token) {
                config.headers.Authorization = `${token}`;
            }
        }
        return config;
    },
    error => Promise.reject(error)
);

aoneMobileInstance.interceptors.request.use(
    config => {
        if (config.baseURL === AONE_MOBILE_BASE_URL && !config.headers.Authorization) {
            const token = store.getters.authResponse.user.azureAccessToken;
            if (token) {
                config.headers.Authorization =  `Bearer ${token}`;
            }
        }
        return config;
    },
    error => Promise.reject(error)
);

const preferencesContextPath = "componentmanagement/preferences";
const ticketContextPath = "componentmanagement/tickets";
const userContextPath = "usermanagement/v1/user";
const userPasswordExpiryPath = "usermanagement/v1/passwordExpiry/";
const serviceManagement = "/smfacade/servicemanagement/graphql";
const bookmarksPath = "/componentmanagement/bookmarks"

const api = {
    addInterceptors(instance) {
        instance.interceptorsForResponseTimeAndErrors(graphInstance);
        instance.interceptorsForResponseTimeAndErrors(helpHubInstance);
        instance.interceptorsForResponseTimeAndErrors(bookmarkInstance);
        instance.interceptorsForResponseTimeAndErrors(serviceNowInstance);
        instance.interceptorsForResponseTimeAndErrors(serverlessHubInstance);
        instance.interceptorsForResponseTimeAndErrors(employeeHubNewsInstance);
        instance.interceptorsForResponseTimeAndErrors(aoneMobileInstance);
        instance.interceptorsForResponseTimeAndErrors(autodeskOneWolkenProxyInstance);
    },
    getBookmarks(offset) {
        let path = bookmarksPath;
        if (offset) {
            let queryparam = `offset=${offset}`;
            path = bookmarksPath + "?" + queryparam;
        }
        return bookmarkInstance.get(path);
    },
    saveBookmark(title, url, sourceType, id, isPin = false) {

        var path = bookmarksPath;
        var bookmarkExists = id && id.length > 0;
        if (bookmarkExists) {
            path = `${path}/${id}`
            return bookmarkInstance.put(path, {
                title,
                url,
                sourceType,
                id,
                isPin
            })
        } 
        // bookmark not yet exists
        else {
            return bookmarkInstance.post(path, {
                title,
                url,
                sourceType,
                id,
                isPin
            })
        }
    },
    removeBookmark(id, sourceType) {
        var path = bookmarksPath + `/${id}`;
        if (sourceType) {
            let queryparam = `sourceType=${sourceType}`;
            path = path + "?" + queryparam;
        }
        return bookmarkInstance.delete(path)
    },
    getProfilePicture(userID) {
        return helpHubInstance.get(
            "/avatar/api/v1/users/" + userID + "/profilepicture"
        );
    },
    getImageSignature(requestType) {
        var imageHashAPIUrl = '/cms/v1/images/hash';
        if (requestType) {
            var fullUrl = imageHashAPIUrl + "?requestType=" + requestType;
            if (alias) fullUrl += "&alias=" + alias;
            return serverlessHubInstance.get(fullUrl);
        }
        return serverlessHubInstance.get(imageHashAPIUrl);
    },
    getPlatformCategories() {
        const query = `{
            getAllAppRecords{
                id
                name
                alias
                type
                hideViewAllRelatedArticlesLink
                viewAllUrlFormat
                showAllGuidesLink
                showArticleUpdatedAt
                backgroundGradient
                knowledgeArticleFeedbackExperience
                knowledgeArticleFeedbackPermissions
                useWolken
            }
          }`;
        const variables = {};

        return helpHubInstance.post(
            "/appmanagement/cmsapp/graphql?alias=manage-eh-platforms",
            {
                query,
                variables
            }
        );
    },
    getStandardCategories(platformCategory) {
        const query = `
        {
            standardTaxonomy(platformCategory: "${platformCategory}") {
              categoryId,
              id
              name
              description
            }
          }
        `;
        const variables = {};

        return helpHubInstance.post(serviceManagement, {
            query,
            variables
        });
    },
    getServiceHierarchyTaxonomy(platformCategory) {
        const query = `
        {
            serviceHierarchyTaxonomy(platformCategory: "${platformCategory}") {
              id
              name
              description
              serviceLines {
                id
                name
                description
                services {
                  id
                  name
                  legacySysId
                }
              }
            }
          }
        `;
        const variables = {};

        return helpHubInstance.post(serviceManagement, {
            query,
            variables
        });
    },
    getAnnouncementsByService() {
        const query = `{
                announcements{
                    id
                    title
                    imageUrl
                    description
                    url
                    newTab
                    updatedAt
                }
            }`;
        const variables = {};
        return helpHubInstance.post(serviceManagement, {
            query,
            variables
        });
    },

    getStandardArticles(platformCategory, serviceId) {
        const query = `
        {
            getService(platformCategory: "${platformCategory}", serviceId: "${serviceId}") {
                articles {
                    id
                    name
                    shortDescription
                    content
                    url
                    
                } 
            }
        }
        `;
        const variables = {};

        return helpHubInstance.post(serviceManagement, {
            query,
            variables
        });
    },
    getPlatformArticles(platformCategory, serviceId) {
        const query = `
        {
            getKnowledgeCategory(platformCategory: "${platformCategory}", knowledgeCategoryId: "${serviceId}") {
                id
                name
                articles {
                    id
                    name
                    viewCount
                    shortDescription
                    content
                    url
                    type
                }
            }
        }
        `;
        const variables = {};

        return helpHubInstance.post(serviceManagement, {
            query,
            variables
        });
    },
    getArticleCategories(platformCategory) {
        let query = `
        {
          getKnowledgeCategories(platformCategory:"${platformCategory}"){
            articles {
              id
              name
              viewCount
              shortDescription
              content
              url
              type
            } 
            id
            name
            serviceNowSysId
          }
        }
    `;

        const variables = {};

        return helpHubInstance.post(serviceManagement, {
            query,
            variables
        });
    },
    getArticleContent(platformCategory, knowledgeBrowseId) {
        const query = `
        {
            knowledgeById(platformCategory: "${platformCategory}", kbId: "${knowledgeBrowseId}") {
                id
                name
                kbNumber
                createdAt
                shortDescription
                updatedAt
                contentUpdatedAt
                kbCategory
                kbCategoryName
                createdBy
                type
                content
                viewCount
                rating
                displayAttachments
                attachments {
                  url
                  fileName
                }
                relatedtArticles {
                  id
                  name
                  url
                }
                feedbackList{
                  articleId
                  comments
                  id
                  rating
                  useful
                  user
                  createdAt
                  updatedAt
                  fullName
                }
            }
        }
        `;
        const variables = {};

        return helpHubInstance.post(serviceManagement, {
            query,
            variables
        });
    },
    getFaqContent(platformCategory, faqId) {
        const query = `
        {
            faqById(platformCategory: "${platformCategory}", faqId: "${faqId}") {
                id
                name
                kbNumber
                createdAt
                shortDescription
                updatedAt
                contentUpdatedAt
                kbCategory
                kbCategoryName
                createdBy
                type
                content
                viewCount
                rating
                displayAttachments
                attachments {
                  url
                  fileName
                }
            }
        }
        `;
        const variables = {};

        return helpHubInstance.post(serviceManagement, {
            query,
            variables
        });
    },
    getArticleComments(articleId) {
        let resourceUrl = CONSTANTS.SNOW_KB_FEEDBACK_RESOURCE_URL;
        let queryParam = `sysparm_query=ORDERBYDESCsys_created_on&article=${articleId}&sysparm_fields=user.user_name,sys_created_by,sys_created_on,comments,parent_comment,sys_id,u_email_only`;
        let url = resourceUrl + "?" + queryParam;
        return serviceNowInstance.get(url);
    },
    getWolkenArticleComments(articleId) {
        let resourceUrl = CONSTANTS.AUTODESK_ONE_WOLKEN_PROXY_FEEDBACK_URL + `/${articleId}`;
        return autodeskOneWolkenProxyInstance.get(resourceUrl);
    },

    setArticleFeedback(requestBody) {
        let url = CONSTANTS.SNOW_KB_FEEDBACK_RESOURCE_URL;
        return serviceNowInstance.post(url, requestBody);
    },

    setWolkenArticleFeedback(requestBody, platformCategory) {
        const knowledgeFeedbackRequest = {
            comments: requestBody.comments,
            articleId: requestBody.article,
            rating: parseInt(requestBody.rating, 10)
        };

        // Escape all double quotes in the comment string
        const escapedComments = knowledgeFeedbackRequest.comments.replace(/"/g, '\\"');

        const mutation = `
            mutation {
                addKnowledgeFeedback(platformCategory: "${platformCategory}", knowledgeFeedbackRequest: {
                    comments: "${escapedComments}",
                    articleId: "${knowledgeFeedbackRequest.articleId}",
                    rating: ${knowledgeFeedbackRequest.rating}
                }) {
                    rating
                    comments
                    useful
                    articleId
                }
            }
        `;

        return helpHubInstance.post(serviceManagement, {
            query: mutation
        });
    },

    setArticleFeedbackTask(requestBody) {
        let url = CONSTANTS.SNOW_KB_FEEDBACK_TASK_RESOURCE_URL;
        return serviceNowInstance.post(url, requestBody);
    },

    getRecommendationsByUserProfile() {
        let query = `
      query {
        quickSolutions {
          newTab
          title
          tag
          createdAt
          id
          url
          description
          image
        }
      }`

        return helpHubInstance.post(serviceManagement, {
            query
        });

    },

    getPopularApps() {
        let query = `
      query {
        popularApps {
        createdAt
        id
        image
        newTab
        title
        updatedAt
        url
        }
      }`

        return helpHubInstance.post(serviceManagement, {
            query
        });
    },

    getPreferences() {
        return helpHubInstance.get(preferencesContextPath);
    },
    getUser(userId) {
        return helpHubInstance.get(userContextPath + "?userName=" + userId);
    },
    getTickets() {
        return helpHubInstance.get(ticketContextPath);
    },
    getUserPasswordExpiryDays(userId) {
        return helpHubInstance.get(userPasswordExpiryPath + userId);
    },
    setPreferences(preferences, preferencesUpdateUrl) {
        var filteredPreferences = preferences
            .filter(preference => preference.isActive)
            .map(preference => preference.id);
        return helpHubInstance.put(
            preferencesUpdateUrl,
            JSON.stringify(filteredPreferences),
            {
                headers: {
                    "Content-Type": "text/plain"
                }
            }
        );
    },
    getPage(id) {
        return serverlessHubInstance.get("/cms/v1/pages/" + id + "?type=Published");
    },
    getService(id) {
        return helpHubInstance.get("/servicemanagement/v1/services/" + id);
    },
    // Used to retrieve the full name of a user
    getUserInfo(userID) {
        return helpHubInstance.get("/usermanagement/v1/user?userName=" + userID);
    },
    getUserInfoByEmail(userEmail) {
        return helpHubInstance.get("/usermanagement/v1/autocomplete/users?query=" + userEmail);
    },
    filterUserGroups(groupId) {
        let url = "/me/memberOf?$count=true";
        if (groupId) url += `&$filter=id eq '${groupId}'`
        return graphInstance.get(url);
    },
    searchUserGroups(displayName) {
        let url = "/me/memberOf?$count=true";
        if (displayName) url += `&$search="displayName:${displayName}"`
        return graphInstance.get(url);
    },
    getUserCriteria() {
        let url = "/oauth2/usercriteria"
        return helpHubInstance.get(url);
    },

    getDriveItemThumbnail(url) {
        return microsoftGraphClient.api(url).get();
    },

    batchGetDriveItemThumbnails(requests) {
        let url = "/$batch"
        let body = { requests: requests }
        return microsoftGraphClient.api(url).post(body);
    },

    getTargetedEventsSites() {
        let siteId = SHAREPOINT_SITE_ID;
        let listId = EVENTS_LIST_ID;
        let url = `/sites/${siteId}/lists/${listId}/items?$expand=fields&filter=fields/Disabled+eq+0`
        return microsoftGraphClient.api(url).get();
    },

    getTargetedEvents(currentDateTime, siteIdsList) {
        let url = "/search/query"
        let queryString = siteIdsList.join(" OR ")

        let body = {
            "requests": [
                {
                    "entityTypes": [
                        "listItem"
                    ],
                    "query": {
                        "queryString": "contentclass:STS_ListItem_Events",
                        "queryTemplate": `(EventsRollUpEndDate>=\"${currentDateTime}\" AND IsExternalContent=\"false\") AND NormSiteID:(${queryString}) (ContentTypeId:0x0102*) (ModernAudienceAadObjectIds:{User.Audiences} OR NOT IsAudienceTargeted:true)`
                    },
                    "from": 0,
                    "size": 10,
                    "fields": [
                        "listItemID",
                        "normListID",
                        "spWebUrl",
                        "title",
                        "author",
                        "isAllDayEvent",
                        "eventsRollUpStartDate",
                        "eventsRollUpEndDate"
                    ],
                    "sortProperties": [
                        {
                            "name": "eventsRollUpStartDate",
                            "isDescending": false
                        }
                    ]
                }
            ]
        }


        return microsoftGraphClient.api(url).post(body);
    },

    getCampaignInfo(currentDateTime) {
        // currentDateTime is a UTC formatted string
        try {
            const url = `/sites/${SHAREPOINT_SITE_ID}/lists/${CAMPAIGN_ITEM_ID}/items?$expand=fields($select=ID,BannerTitle,Subtitle,BannerType,BannerButton,BannerAdditionalInfo,StartDate,ExpiryDate)&$filter=fields/StartDate le '${currentDateTime}' and fields/ExpiryDate ge '${currentDateTime}'&$orderby=fields/StartDate desc`;
            return microsoftGraphClient.api(url).get();
        } catch (error) {
            throw error;
        }
    },

    batchGetCampaignImages(requests) {
        try {
            let url = "/$batch"
            let body = { requests: requests }
            return microsoftGraphClient.api(url).post(body);
        } catch (error) {
            throw error;
        }
    },

    getOutageBannerInfo() {
        try {
            const url = `/sites/${SHAREPOINT_SITE_ID}/lists/${OUTAGE_BANNER_ITEM_ID}/items?$expand=fields&$orderBy=fields/Created desc`
            return microsoftGraphClient.api(url).get();
        } catch (error) {
            throw error;
        }
    },

    getNewsPosts(offset, size) {
        let queryParams = `(offset: ${offset}, size: ${size})`;
        let query = `

        query {
            news ${queryParams} {
                total
                offset
                news { 
                    id
                    title
                    url
                    description
                    imageUrl
                    fallbackImageUrl
                    date
                    categories
                }
                
            }
        }
      `
        return employeeHubNewsInstance.post("", { query });
    },

    updateRSVP(itemId, listId,siteId ,isDelete) {
        let queryParams = `(itemId: "${itemId}", listId: "${listId}",siteId: "${siteId}")`;
        if(isDelete){
            queryParams = `(itemId: "${itemId}", listId: "${listId}",siteId: "${siteId}",isDelete: true)`;
        }
        let query = `
            mutation MyMutation {
            rsvpToEvent${queryParams} {
                error
                success
                }
            }
      `
        return employeeHubNewsInstance.post("", { query });
    },

    getNewsByInterests(offset, size) {
        let queryParams = `(offset: ${offset}, size: ${size})`;

        let query = `
            query {
                newsByInterest ${queryParams} {
                    news {
                        total
                        offset
                        size
                        news {
                            id
                            title
                            description
                            date
                            url
                            imageUrl
                            fallbackImageUrl
                            topic
                        }
                    }
                    topics {
                        category
                        id 
                        title
                        subscribed
                        orgTopic
                        default
                    }
                }
            }
        `
        return employeeHubNewsInstance.post("", { query });
    },

    getFilteredNewsPosts(offset, size, filters) {
        let query = `
            query news($offset: Int, $size: Int, $filters: NewsFilters) {
                news (offset: $offset, size: $size, filters: $filters) {
                    total
                    offset
                    news { 
                        id
                        title
                        url
                        description
                        imageUrl
                        fallbackImageUrl
                        date,
                        categories
                    }
                }
            }
        `
        return employeeHubNewsInstance.post("", { query,  variables: { offset, size, filters } });
    },

    getNewsCategories() {
        let query = "query { newsCategories }"
        return employeeHubNewsInstance.post("", { query });
    },

    getEventsByInterest(offset, size) {
        let queryParams = `(offset: ${offset}, size: ${size})`;

        let query = `
            query {
                eventsByInterest ${queryParams} {
                    topics {
                        category
                        default
                        id
                        orgTopic
                        subscribed
                        title
                    }
                    events {
                        total
                        offset
                        size
                        events {
                            id
                            uniqueId
                            url
                            title
                            description
                            startDate
                            endDate
                            topic
                            location
                            isAllDay
                            siteId
                            listId
                            rsvpUsers {
                                email
                            }
                            rsvpCount
                            enableRsvp
                            rsvpDeadline
                        }
                    }
                }
            }
        `
        return employeeHubNewsInstance.post("", { query });
    },

    updateNewsTopicSubscriptions(subscriptions) {
        // format query parameter
        let subscriptionsStr = ''
        subscriptions.forEach(s => subscriptionsStr += `{ id: "${s.id}", subscribe: ${s.subscribe}}`)
        let queryParam = `[${subscriptionsStr}]`

        let query = `
            mutation {
                subscribeToTopics(topicSubScribeRequest: ${queryParam
            }) {
                    success
                    error
                }
            }
        `;

        return employeeHubNewsInstance.post("", { query });
    },

    updateEventsTopicsSubscriptions(subscriptions) {
        let subscriptionsStr = ''
        subscriptions.forEach(s => subscriptionsStr += `{ id: "${s.id}", subscribe: ${s.subscribe}}`)
        let queryParam = `[${subscriptionsStr}]`

        let query = `
            mutation {
                subscribeToTopics(type: "EVENTS", topicSubScribeRequest: ${queryParam
            }) {
                    success
                    error
                }
            }
        `;

        return employeeHubNewsInstance.post("", { query });
    },

    getUserCalendarEvents() {
        let query = `
            query {
                getUserCalendarEvents {
                    email
                    endDate
                    id
                    startDate
                    title
                    outlookId
                }
            }
        `

        return aoneMobileInstance.post("", { query });
    },

    createCalendarEvent(input) {
        let query = `
            mutation CreateCalendarEvent($input: CreateCalendarEventInput!) {
                createCalendarEvent(createCalendarEventInput: $input) {
                    id
                    endDate
                    email
                    startDate
                    title
                }
            }
        `;

        return aoneMobileInstance.post("", { query, variables: { input } });
    },
    addEvent(input,rsvp) {
        let query = `
            mutation addToCalendar($input: AddToCalendarEventInput!) {
                addToCalendar(event: $input, rsvpFlag: ${rsvp}) {
                    id
                    endDate
                    email
                    startDate
                    title
                    outlookId
                }
            }
        `;

        return aoneMobileInstance.post("", { query, variables: { input } });
    },
     deleteEvent(input) {
        let query = `
            mutation deleteCalendarEvent($input: DeleteCalendarEventInput!) {
                deleteCalendarEvent(deleteCalendarEventInput: $input, rsvpFlag: true) {
                    email
                    id
                }
            }`;
    
        return aoneMobileInstance.post("", { query, variables: { input } });
    },

    addEventToCalendar(event) {
        let url = "/me/events"
        let body = {
            "subject": event.title,
            "isAllDay": event.isAllDay,
            "body": {
                "contentType": 'HTML',
                "content": event.description
            },
            "start": {
                "dateTime": event.startDate,
                "timeZone": "UTC"
            },
            "end": {
                "dateTime": event.endDate,
                "timeZone": "UTC"
            },
            "location": {
                "displayName": event.location
            }
        };

        return microsoftGraphClient.api(url).post(body);
    },

    getSharepointBookmarks() {
        // https://graph.microsoft.com/v1.0/me/followedSites
        let url = "/me/followedSites"
        return microsoftGraphClient.api(url).get();
    },

    getMyContent() {
        let url = `/sites/${SHAREPOINT_SITE_ID}/lists/${MY_CONTENT_LIST_ID}/items?expand=fields&$orderBy=fields/Position`
        return microsoftGraphClient.api(url).get();
    },

    getRecommendations() {
        let listId = RECOMMENDATIONS_LIST_ID;
        let url = `/sites/${SHAREPOINT_SITE_ID}/lists/${listId}/items?expand=fields&$orderBy=fields/Position`
         return microsoftGraphClient.api(url).get();
    },

    getActivePopupVideoCampaign() {
        const fields = ["ID", "Title", "LocalStorageKey", "Copy", "CallOutAction", "VideoURL", "GIFURL", "Active", "_ModernAudienceAadObjectIds"];
        let listId = POPUP_VIDEO_CAMPAIGN_LIST_ID;
        let url = `/sites/${SHAREPOINT_SITE_ID}/lists/${listId}/items?top=1&$expand=fields($select=${fields})&$filter=fields/Active eq 1`
         return microsoftGraphClient.api(url).get();
    },

    getVideoCampaigns(currentDateTime) {
        try {
            const fields = ["ID", "Title", "Summary", "URL", "StartDate", "ExpiryDate", "CTA"];
            const url = `/sites/${SHAREPOINT_SITE_ID}/lists/${VIDEO_CAMPAIGN_LIST_ID}/items?$top=1&$expand=fields($select=${fields})&$filter=fields/StartDate le '${currentDateTime}' and fields/ExpiryDate ge '${currentDateTime}'&$orderby=fields/StartDate desc`;
            return microsoftGraphClient.api(url).get();
        } catch (error) {
            throw error;
        }
    },

    getVideoCampaignPreview(itemId) {
         let url = `/sites/${SHAREPOINT_SITE_ID}/lists/${VIDEO_CAMPAIGN_LIST_ID}/items/${itemId}/driveItem/preview`
         return microsoftGraphClient.api(url).post();
    },
  
    getNewsSummary(requestId) {
        let query = `
        {
        summarizeNews(offset: 0, size:7, requestId: "${requestId}")
        }`;
        return aoneGenAiInstance.post('/graphql', { query });
    },

    getCountdownTimer(){
        let url = `/sites/${SHAREPOINT_SITE_ID}/lists/${COUNTDOWN_TIMER_ITEM_ID}/items?expand=fields($select=CTA,TitleDescription,EventStartDate,NotificationStartDate,EventUrl,status,FooterBackgroundColor,TimerTextColor,TimerBackgroundColor,Logo)`
        return microsoftGraphClient.api(url).get();
    }
};

export default api;
